import React, { useEffect, useState } from 'react';
import { get } from "lodash";
// import { loadState } from '../../store/LocalStorage'
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from 'react-router-dom'

function UpdateManIntents(props) {
    // const history=useHistory();
    const navigate = useHistory();
    const [Emotion, setEmotion] = React.useState('');
    const [EType, setType] = React.useState('');
    const [formData, setName] = useState({ intents: "", IntDesc: "", Ans1: "", Ans2: "" });
    const IntId = localStorage.getItem('IntentInfo');
    const backchar = localStorage.getItem('BackIntent');
    const UserRole = localStorage.getItem('URole');
    const QLength = localStorage.getItem('QuestionLength');
    const mangerId = localStorage.getItem('ManegerId');
    // const [PortalList, setPortalList] = useState([])
    // const [PoralId, setPortalId] = React.useState('');
    // const [selectPortal, setselectPortal] = useState([])
    const PtId = localStorage.getItem('PatQusId');


    // const { IntId, Ques} = get(loadState(), "IntId") || {};
    //console.log("pass id", IntId)
    useEffect(() => {

        LoadIntents();
        // LoadPortalByIntent();
        // LoadPortalByPatient();

    }, [])

    const LoadIntents = () => {

        const datavalue = {
            id: IntId
        }
        // const config = {

        //     headers: { 'content-type': 'multipart/form-data' }
        // }
        var authOptions = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/getIntentsByid`,
            data: datavalue,
            headers: { 'Content-Type': 'multipart/form-data' },
        };
        axios(authOptions)
            // axios.post(`https://localhost:7261/getIntentsByid`, datavalue, config)
            .then(res => {
                //console.log("get value", res);
                //console.log("list", res.data.result[0].id)
                // setIntentList(res.data)
                setName({ intents: res.data.result[0].Intents, IntDesc: res.data.result[0].Intent_Desc, Ans1: res.data.result[0].Responce1, Ans2: res.data.result[0].Responce2 });
                setEmotion(res.data.result[0].Emotion)
                setType(res.data.result[0].Emo_Type)
            })
    }
    // const LoadPortalByIntent = () => {
    //     const datavalue = {
    //         IntId: IntId
    //     }
    //     var authOptions = {
    //         method: "post",
    //         url: `${process.env.REACT_APP_API_URL}/getPortalByIntentId`,
    //         data: datavalue,
    //         headers: { 'Content-Type': 'multipart/form-data' },
    //     };
    //     axios(authOptions)
    //         .then(res => {
    //             //console.log("Filter single portal", res.data[0].id)
    //             setselectPortal(res.data[0].id == 0 ? "" : res.data[0].id)
    //             setPortalId(res.data[0].id == 0 ? "" : res.data[0].id);
    //             // setselectPortal("")
    //             // setSelectedOptions.map(
    //             //         option => option.find(o => o.ID === option.UID))
    //         })
    // }
    // const LoadPortalByPatient = () => {
    //     const datavalue = {
    //         PatientId: PtId
    //     }
    //     var authOptions = {
    //         method: "post",
    //         url: `${process.env.REACT_APP_API_URL}/getPortalByPatientId`,
    //         data: datavalue,
    //         headers: { 'Content-Type': 'multipart/form-data' },
    //     };
    //     axios(authOptions)
    //         .then(res => {

    //             setPortalList(res.data)

    //         })
    // }

    const IntentSubmit = async (e) => {
        e.preventDefault();

        //console.log("formData", formData)

        let formDataSet = new FormData();
        //formdata object
        if (formData.intents === "" || formData.Ans1 === "" || formData.Ans1 == null || formData.Ans2 == null || formData.Ans2 === "" || Emotion == "") {
            if (formData.intents === "") {
                Swal.fire({
                    title: "Error",
                    text: "Question Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });

            } else if (formData.Ans1 === "") {
                Swal.fire({
                    title: "Error",
                    text: "Answer1 Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            } else if (Emotion === "") {
                Swal.fire({
                    title: "Error",
                    text: "Emotion Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });

                // } else if (PoralId === "") {
                //     Swal.fire({
                //         title: "Error",
                //         text: "Please Select Portal",
                //         icon: "error",
                //         confirmButtonText: "Ok",
                //     });


            } else {
                Swal.fire({
                    title: "Error",
                    text: "Answer2 Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }
        } else {
            formDataSet.append('Intents', formData.intents);   //append the values with key, value pair
            formDataSet.append('Intent_Desc', formData.IntDesc == "" ? "custom" : formData.IntDesc);
            formDataSet.append('Responce1', formData.Ans1 == null || formData.Ans1 == "" ? "0" : formData.Ans1);
            formDataSet.append('Responce2', formData.Ans2 == null || formData.Ans2 == "" ? "0" : formData.Ans2);
            formDataSet.append('Emotion', Emotion);
            formDataSet.append('Emo_Type', EType == "" ? "No" : EType);
            formDataSet.append('Id', IntId);
            // formDataSet.append('PortId', PoralId);
            formDataSet.append('P_id', "0");
            formDataSet.append('MangerId', mangerId);

            // const config = {
            //     headers: { 'content-type': 'multipart/form-data' }
            // }
            var authOptions = {
                method: "post",
                url: `${process.env.REACT_APP_API_URL}/updateIntentsByManagerId`,
                data: formDataSet,
                headers: { 'Content-Type': 'multipart/form-data' },
            };
            axios(authOptions)
                //axios.post(`https://localhost:7261/updateIntentsByid`, formDataSet, config)
                .then(res => {
                    //console.log("get value", res);

                    //console.log("success")
                    // setName({ intents: "", Ans1: "", Ans2: "" });
                    Swal.fire({
                        title: "Success",
                        text: "Question and Answer Update Successfully",
                        icon: "success",
                        confirmButtonText: "Ok",
                    }).then(function () {

                        // navigate.push('/IntentList');
                        // UserRole === "Admin" ?  navigate.push('/PtientIntentList'): navigate.push('/PtientIntentList')
                    });



                })
                .catch(error => {
                    //console.log("error occur", error);
                })
        }

    }
    // const handleChangePortal = (event) => {

    //     setPortalId(event.target.value);
    //     setselectPortal(event.target.value)

    //     //console.log("selected Portal", event.target.value)

    // };

    const handleChangeDrp = (event) => {

        setEmotion(event.target.value);
        //console.log("selected emo", event.target.value)

    };
    const handleChangeType = (event) => {

        setType(event.target.value);
        //console.log("selected emo", event.target.value)

    };
    const BackFunc = () => {
        // backchar == 'Intentback' ? navigate.push('/IntentList') : navigate.push('/PtientIntentList');
        // QLength > 10 ? navigate.push('/PtientIntentList') : navigate.push('/PtientCusIntentList')
        navigate.push('/ManIntentList')
    }

    const handleChange = (e) => {
        setName({ ...formData, [e.target.name]: e.target.value });
    };
    return (
        <>
            <div className="page-content-wrapper">
                <div className="page-content">
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            <div className=" pull-left">
                                <div className="page-title">Update Question and Answer</div>
                            </div>
                            <div className=" pull-right">
                                <button type="submit" className="btn btn-primary d-inline-block" onClick={BackFunc}> <i className="fa fa-arrow-left" aria-hidden="true"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="card card-box">

                                <div className="card-body " id="bar-parent">
                                    <form className="register-form" id="login-form" onSubmit={IntentSubmit}>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className='col-12 col-md-6'>
                                                    <label for="simpleFormEmail" className="control-label">Intent</label><i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red", padding: "4px" }} />
                                                    <input type="text"
                                                        value={formData.intents}
                                                        onChange={handleChange}
                                                        name="intents" className="form-control" id="simpleFormEmail"
                                                        placeholder="Enter Intent" />

                                                </div>
                                                <div className='col-12 col-md-6'>
                                                    <label for="simpleFormPassword" className="control-label">Question Text</label><i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red", padding: "4px" }} />
                                                    <input type="text"
                                                        value={formData.IntDesc}
                                                        onChange={handleChange}
                                                        name="IntDesc" className="form-control" id="ans1"
                                                        placeholder="Question Description" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label for="simpleFormPassword" className="control-label">Answer 1</label><i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red", padding: "4px" }} />
                                            <textarea type="text"
                                                value={formData.Ans1}
                                                onChange={handleChange}
                                                name="Ans1" className="form-control" id="ans1"
                                                placeholder="Answer 1" />
                                        </div>
                                        <div className="form-group">
                                            <label for="simpleFormPassword" className="control-label">Answer 2</label><i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red", padding: "4px" }} />
                                            <textarea type="text"
                                                value={formData.Ans2}
                                                onChange={handleChange}
                                                name="Ans2" className="form-control" id="ans2"
                                                placeholder="Answer 2" />
                                        </div>
                                        <div className="form-group">

                                            <div className="form-group row">
                                                <div className="col-md-6 col-sm-6">
                                                    <label className="col-lg-3 col-md-4 control-label">Emotion
                                                    </label>
                                                    <select className="form-control  select2" value={Emotion} onChange={handleChangeDrp}>
                                                        <option value="">Select Emotion</option>
                                                        <option value="Sad">Sad</option>
                                                        <option value="Angry">Angry</option>
                                                        <option value="Happy">Happy</option>
                                                        <option value="Neural">Neutral</option>

                                                    </select>
                                                </div>

                                                <div className="col-md-6 col-sm-6">
                                                    <label className="col-lg-3 col-md-4 control-label">Type
                                                    </label>
                                                    <select className="form-control  select2" value={EType} onChange={handleChangeType}>
                                                        {/* <option value="">Select Type</option>
                                                            <option value="Custom">Custom</option> */}
                                                        <option value="All">All</option>

                                                    </select>
                                                </div>
                                            </div>
                                            {/* </div> */}
                                        </div>
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UpdateManIntents;